import * as Yup from 'yup';

export default Yup.object().shape({
  validUntil: Yup
    .date()
    .required()
    .min(new Date(), 'La data di validità deve essere nel futuro'),
});
